var __rspack_ns_object = JSON.parse('{"TABS":{"OVERVIEW":"GENERAL","TOUR_REP_SELF_PROMOTE":"Tourrep + Self Promote","SETTLEMENTS":"Settlements"}}')